import {
  LinkIcon_default
} from "./chunk-RMO2ZNHC.mjs";
export {
  LinkIcon_default as default
};
